import { memo, useEffect } from 'react'
import { css, jsx } from '@emotion/react'
import ExtensionHeader from '../ExtensionHeader'
import useResponsive from '../../../utils/hooks/useResponsive'
import FavDataWrapper from './FavDataWrapper'
import { toastError } from '../../../constants'
import { useGetExtensionFavBookmarks } from '../../../services/extension'

const styles = {
  container: css`
    height: 100%;
    overflow: hidden;
  `,
  listContent: headerHeight => css`
    height: calc(100% - ${headerHeight}px);
    width: 100%;
  `,
}

function FavPage() {
  const { bookmarks, isErrorBookmarks } = useGetExtensionFavBookmarks()

  useEffect(() => {
    if (isErrorBookmarks) {
      toastError('bookmarks')
    }
  }, [isErrorBookmarks])
  const padding = useResponsive('10px', '15px')
  const headerHeight = useResponsive(46, 53)

  return (
    <div css={styles.container}>
      <ExtensionHeader headerHeight={headerHeight} padding={padding} />
      <div css={styles.listContent(headerHeight)}>
        <FavDataWrapper
          padding={padding}
          bookmarks={bookmarks}
          headerHeight={headerHeight}
          isErrorBookmarks={isErrorBookmarks}
        />
      </div>
    </div>
  )
}

export default memo(FavPage)
